module.exports = __webpack_public_path__ + "static/media/cases_anuncios_02a.cd5cf256.jpg";